<template>
  <com-header :actived="2"></com-header>
  <div class="paper-container inner-container">
    <inner-banner
      :img="bannerImg"
      title="纸媒管理系统"
      brief="从线下到线上的转变过程，纸媒印刷文件通过数字化标引入库，形成云报资源库，多端发布呈现，提供云报的生产代工标引服务，涵盖统计分析，实现了数据查询、数字简报、考核评分等功能"
    ></inner-banner>
    <com-title class="mt-20" title="产品优势"></com-title>
    <div class="advantage-box mt-20">
      <div class="common-container flex justify-between">
        <div class="advantage-item wow bounceInUpSlow" data-wow-delay="0.1s">
          <icon-card class="yellow-org" :img="img1" title="基于云计算制作发布系统"></icon-card>
        </div>
        <div class="advantage-item wow bounceInUpSlow" data-wow-delay="0.2s">
          <icon-card
            :img="img2"
            title="采用阿里云检索技术，快速检索海量数据，可随时根据访问量调整服务器容量和流量"
          ></icon-card>
        </div>

        <div class="advantage-item wow bounceInUpSlow" data-wow-delay="0.3s">
          <icon-card class="green-grass " :img="img3" title="支持音视频关联"></icon-card>
        </div>
        <div class="advantage-item wow bounceInUpSlow" data-wow-delay="0.4s">
          <icon-card  :img="img4" title="支持第三方数据导入"></icon-card>
        </div>
      </div>
    </div>
    <div class="trait-box">
      <div class="common-container">
        <com-title title="主要特点"></com-title>

        <div class="trait-list mt-10 swiper-trait">
          <swiper
            :modules="modules"
            @swiper="onSwiper"
            @slideChange="onSlideChange"
            navigation
            :slides-per-view="3"
            :space-between="40"
            :pagination="{ clickable: true }"
            autoplay
            loop
          >
            <swiper-slide>
              <div class="trait-item">
                <div class="photo">
                  <img src="@/assets/images/product-img03.png" alt />
                </div>
                <div class="text">
                  <h3>智能语音</h3>
                  <p>可切换男声、女声，带来极致悦耳体验</p>
                </div>
              </div>
            </swiper-slide>
            <swiper-slide>
              <div class="trait-item">
                <div class="photo">
                  <img src="@/assets/images/product-img01.png" alt />
                </div>
                <div class="text">
                  <h3>当期视频</h3>
                  <p>视频列表，合集呈现，精彩观看</p>
                </div>
              </div>
            </swiper-slide>
            <swiper-slide>
              <div class="trait-item">
                <div class="photo">
                  <img src="@/assets/images/product-img02.png" alt />
                </div>
                <div class="text">
                  <h3>多图海报分享</h3>
                  <p>个性化分享，让分享充满乐趣，便于内容传播</p>
                </div>
              </div>
            </swiper-slide>
            <swiper-slide>
              <div class="trait-item">
                <div class="photo">
                  <img src="@/assets/images/product-img02.png" alt />
                </div>
                <div class="text">
                  <h3>热门推荐</h3>
                  <p>智能推荐当期热文、要闻等实时资讯</p>
                </div>
              </div>
            </swiper-slide>
          </swiper>
        </div>
      </div>
    </div>
    <div class="yinyong-box mt-20">
      <div class="common-container wow bounceInUpSlow"  data-wow-delay="0.25s">
        <com-title title="应用场景"></com-title>
        <ul class="mt-6">
          <li>网站端报刊：提供数字报刊内容采集、编辑及发布的整个数字报刊制作发布过程的工作平台。系统操作界面简洁灵活，用户能够灵活的制作模板、方便地组织数字报刊内容，完成报刊组织、传送、签发等一系列数字报刊的制作流程。</li>
          <li>移动端报刊：系统提供原版期刊手机端阅读适配，其真正实现了报纸杂志在手机上的原版显示，功能强大，操作简便，将带给人们全新的阅读体验。</li>
          <li>老报老期刊：纸质报刊数字化加工流程主要包括出版物清点核对、扫描修图、OCR文字识别与校对、文章人工标引、NLP智能标引、制作PDF文件、综合质检、数据入库等主要加工环节。</li>
        </ul>
      </div>
    </div>
    <div class="case-box">
      <div class="common-container">
        <com-title title="客户案例"></com-title>
        <div class="case-list flex justify-between">
          <div class="case-item  wow  bounceInUpSlow"  data-wow-delay="0.1s">
            <img src="@/assets/images/other/zhimei-case01.jpeg" alt />
          </div>
          <div class="case-item  wow  bounceInUpSlow"  data-wow-delay="0.15s">
            <img src="@/assets/images/other/zhimei-case02.jpeg" alt />
          </div>
          <div class="case-item  wow  bounceInUpSlow"  data-wow-delay="0.2s">
            <img src="@/assets/images/other/zhimei-case03.jpeg" alt />
          </div>
          <div class="case-item  wow  bounceInUpSlow"  data-wow-delay="0.25s">
            <img src="@/assets/images/other/zhimei-case04.jpeg" alt />
          </div>
        </div>
      </div>
    </div>
  </div>
  <com-footer></com-footer>
</template>
<script setup>
import { Navigation, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/vue/swiper-vue.js';
import bannerImg from '@/assets/images/product-banner.png'
import { ref } from 'vue'
import img1 from '@/assets/images/power-img01.png'
import img2 from '@/assets/images/power-img02.png'
import img3 from '@/assets/images/power-img03.png'
import img4 from '@/assets/images/power-img04.png'

const onSwiper = (swiper) => {
  // console.log(swiper);
};
const onSlideChange = () => {
  // console.log('slide change');
};
const modules = ref([Navigation, Pagination])
</script>
<style>
/* @import "@/assets/style/inner.less"; */
.inner-container .advantage-item .iconCard{
   height: 100%;
}
</style>